module.exports = __webpack_public_path__ + "static/media/star_guang.c36710f2.png";